import WrapperInterface from '../utils/WrapperInterface';
import { getWrapperInterface } from '../utils/index';

class AppVersion {
  major: number;
  minor: number;
  patch: number;

  constructor(version: string) {
    const parts = version.split('.');
    this.major = parseInt(parts[0], 10);
    this.minor = parseInt(parts[1], 10);
    this.patch = parseInt(parts[2], 10);
  }

  isNewerThan(other: AppVersion) {
    return (
      this.major > other.major ||
      this.minor > other.minor ||
      this.patch > other.patch
    );
  }
}

export const getWrapperVersion = (): AppVersion => {
  let version = '1.0.0';
  const wi = getWrapperInterface();
  if (wi !== null) {
    version = (wi as WrapperInterface).getWrapperVersion().version;
  }
  return new AppVersion(version);
};

export const wrapperVersionWithoutGIFCompression = new AppVersion('1.0.4');

export default AppVersion;



// WEBPACK FOOTER //
// ./src/data/AppVersion.ts